import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Después de meses de tristeza, ahora mi esposo y yo hablamos como antes. Las risas volvieron a nuestro hogar.',
    author: 'María G.',
    location: 'Monterrey'
  }, {
    quote: 'Pensé que todo estaba perdido. Pero seguí el método y hoy siento que recuperamos la complicidad que nos unió.',
    author: 'Ana C.',
    location: 'Miami'
  }, {
    quote: 'Esta guía me ayudó a entender que el problema no era mi esposo ni yo, sino la desconexión. Ahora nos sentimos más cerca que nunca.',
    author: 'Patricia R.',
    location: 'New York'
  }, {
    quote: 'Los microgestos cambiaron todo. Mi esposo volvió a mirarme con amor y yo volví a sentirme valorada. Gracias por este regalo.',
    author: 'Carmen S.',
    location: 'Bogotá'
  }, {
    quote: 'No necesité terapia ni confrontaciones. Solo seguí los pasos y vi cómo nuestro matrimonio renacía día a día.',
    author: 'Isabella M.',
    location: 'Washington'
  }];
  return <section className="py-8 md:py-12 bg-white" data-id="element-184">
      <div className="max-w-6xl mx-auto px-6" data-id="element-185">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-serif text-center text-[#2d2d2d] mb-12" data-id="element-186">
          TESTIMONIOS REALES
        </motion.h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-187">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#faf8f6] p-6 md:p-8 rounded-2xl relative" data-id="element-188">
              <Quote className="absolute top-6 left-6 w-8 h-8 text-[#d4a5a5]/30 rotate-180" data-id="element-189" />
              <div className="relative z-10 pt-6" data-id="element-190">
                <p className="text-base md:text-lg text-[#5a5a5a] italic mb-6 leading-relaxed" data-id="element-191">
                  "{item.quote}"
                </p>
                <div className="flex items-center gap-3" data-id="element-192">
                  <div className="w-10 h-10 bg-[#9d4b6b]/10 rounded-full flex items-center justify-center text-[#9d4b6b] font-serif font-bold" data-id="element-193">
                    {item.author.charAt(0)}
                  </div>
                  <div data-id="element-194">
                    <p className="font-bold text-[#2d2d2d]" data-id="element-195">{item.author}</p>
                    <p className="text-sm text-[#8b6f6f]" data-id="element-196">{item.location}</p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}